require('polyfill-object.fromentries');
import 'react-toastify/dist/ReactToastify.css';
import 'react-spring-bottom-sheet/dist/style.css';
import './App.css';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import reducer from './reducers';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import sagas from './sagas';
import { createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import Route from './route';
import ErrorBoundary from './component/error_boundary';
import './utilities/scaling_utils';
import BuildVersionCheck from './component/build_version_check';

const isReleaseBuild = process.env.NODE_ENV === 'production';

// if (isReleaseBuild) {
//   console.log = () => {};
//   console.error = () => {};
//   console.debug = () => {};
//   console.warn = () => {};
// }

const sagaMiddleware = createSagaMiddleware();

const composeEnhancers = composeWithDevTools({});

let middleware = [sagaMiddleware];

export const store = createStore(reducer, composeEnhancers(applyMiddleware(...middleware)));

const persistor = persistStore(store);

sagaMiddleware.run(sagas);

function App() {
  return (
    <ErrorBoundary>
      <Provider store={store}>
        <PersistGate persistor={persistor}>
          <Route />
          <ToastContainer
            position="top-left"
            autoClose={2000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />

          {isReleaseBuild && <BuildVersionCheck />}
        </PersistGate>
      </Provider>
    </ErrorBoundary>
  );
}

export default App;
